import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportResourceAvailability_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportResourceAvailability extends Report<ReportResourceAvailability_Settings> {

    static reportName   : string = "Resource Availability"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_RESOURCE_AVAILABILITY
        super(data);

        this.icon        = "isvg-availability"
        this.description = "Highlights available resources for upcoming work."

        this.settings    = new ReportResourceAvailability_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportResourceAvailability {
        return new ReportResourceAvailability(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportResourceAvailability_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
